@for (campaign of campaigns(); track campaign) {
    <div class="ft-panel ft-campaign-panel" [ngClass]="rootClass(campaign)" (click)="selectCampaign(campaign)">
        <div class="ft-heading ft-text-plus-2">{{ campaignNameKey(campaign) ? (campaignNameKey(campaign) | translate) : campaign.name }}</div>
        <div class="ft-status off" [hidden]="(campaign.isActive | parse: 'bool')">
            <span>{{ 'flipto.account.platform.Inactive' | translate }}</span>
        </div>
        <div class="ft-row">
            <div class="ft-col-30">
                @if (campaign.campaignGuests > 0) {
                    <div class="ft-summary">
                        <strong>{{ campaign.campaignGuests }} {{ 'flipto.account.platform.preStay.campaign.Guests' | translate }}</strong>
                        @if (campaign.type == 255) {
                            <span>
                                {{ 'flipto.account.platform.preStay.campaign.DidNotFallIntoASpecificCampaign' | translate }}
                            </span>
                        }
                        @if (campaign.type != 255) {
                            <span>
                                {{ 'flipto.account.platform.preStay.campaign.MatchedThis' | translate }}
                                @for (key of criteriaKeys(campaign); track key) {<span>{{ key | translate | lowercase }}{{ $last ? '' : ', ' }}</span>}
                                <span [hidden]="(campaign.isActive | parse: 'bool')">
                                    {{ 'flipto.account.platform.preStay.campaign.WhileItWasActive' | translate }}
                                </span>
                            </span>
                        }
                    </div>
                }
            </div>

            <div class="ft-col-30">
                @if (campaign.campaignGuests > 0) {
                    <div class="campaign-stats">
                        <div class="stat">
                            <div class="ft-count">{{ engagementPercent(campaign) | number: '1.0-0' }}%</div>
                            {{ 'flipto.account.Engagement' | translate }}
                            <div class="stat-small">
                                {{ campaign.campaignShares }} {{ 'flipto.account.platform.preStay.campaign.Advocates' | translate }}
                            </div>
                        </div>
                        <div class="stat">
                            <div class="ft-count">{{ visitorsPerAdvocate(campaign) | number: '1.0-0' }}</div>
                            {{ 'flipto.account.Visitors' | translate | lowercase }}
                            <div class="stat-small">{{ 'flipto.account.PerAdvocate' | translate }}</div>
                        </div>
                    </div>
                }
                @if (campaign.campaignUniqueVisitors > 0 && campaign.type == 255) {
                    <div class="campaign-stats">
                        <div class="stat">
                            <div class="ft-count">{{ campaign.campaignUniqueVisitors | number }}</div>
                            {{ 'flipto.account.UniqueVisitors' | translate }}
                        </div>
                        <div class="stat">
                            <div class="ft-count">{{ (campaign.campaignUniqueSignups || 0) | number }}</div>
                            {{ 'flipto.account.VisitorSignups' | translate }}
                        </div>
                    </div>
                }
            </div>

            <div class="ft-col-40">
                <div class="ft-campaign-goal ft-text-minus-1">
                    @if (advocateGoals(campaign).length) {
                        <p>For advocates</p>
                    }
                    @for (goal of advocateGoals(campaign); track goal) {
                        <p>
                            <span class="goal-name ft-emphasis" [innerHTML]="capitalize(goal.name, true)"></span>
                        </p>
                    }
                </div>

                <div class="ft-campaign-goal ft-text-minus-1">
                    @if (warmLeadGoals(campaign).length) {
                        <p>For warm leads</p>
                    }
                    @for (goal of warmLeadGoals(campaign); track goal) {
                        <p>
                            <span class="goal-name ft-emphasis" [innerHTML]="capitalize(goal.name, true)"></span>
                        </p>
                    }
                </div>
            </div>

            <div class="panel-actions" [hidden]="!(sortMode() && campaign.type != 255 && (campaign.isActive | parse: 'bool'))">
                <div class="ft-sort-buttons">
                    <a class="ft-btn-sort" [class.disabled]="$first" (click)="moveUp(campaign, $event)">
                        <i class="ft-icn-arrow-up"></i>
                    </a>
                    <a class="ft-btn-sort" [class.disabled]="!canBeMovedDown(campaign)" (click)="moveDown(campaign, $event)">
                        <i class="ft-icn-arrow-down"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
}
